import { useEffect, useState } from 'react';
import { AuthUser } from './types';
import { onAuthChange } from './firebase/auth';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import Loading from './components/Loading';

function App() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthChange((authUser) => {
      setUser(authUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Simple admin detection - you can modify this logic
  const isAdmin = (email: string | null): boolean => {
    if (!email) return false;
    // Add admin emails here - you can modify this logic
    const adminEmails = [
      'admin@mecon.com',
      'muhasebe@meconyapi.com',
      // Add more admin emails as needed
    ];
    return adminEmails.includes(email.toLowerCase());
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {user ? (
        isAdmin(user.email) ? (
          <AdminDashboard user={user} />
        ) : (
          <Dashboard user={user} />
        )
      ) : (
        <Login />
      )}
    </div>
  );
}

export default App; 